import {MBInput} from '../../../Common/Components/MBInput'
import React from 'react'

type MBInputProps = React.ComponentProps<typeof MBInput>
type MBMemberInputProps = Omit<MBInputProps, 'classNameOnError'>
export const MBMemberInput: React.VFC<MBMemberInputProps> = (props) => {
  return (
    <MBInput
      classNameOnError={'_error'}
      {...props}
    >
      {props.children}
    </MBInput>
  )
}
